import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-assign',
  templateUrl: './call-assign.component.html',
  styleUrls: ['./call-assign.component.scss'],
})
export class CallAssignComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
